import { createFileRoute, Link } from "@tanstack/react-router";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PageHeader } from "@/components/PageHeader";
import { FileCheck, BookOpen, ArrowRight } from "lucide-react";

export const Route = createFileRoute("/admin/administrateur/facturation/codage/")({
  component: Codage,
});

function Codage() {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 p-6">
      <PageHeader
        title="Codage NGAP"
        description="Codage des actes techniques · nomenclature NGAP"
        domain="governance"
      />
      <Card className="bg-slate-900/60 border-slate-800 mt-4">
        <CardHeader>
          <CardTitle className="text-base flex items-center gap-2">
            <FileCheck className="h-4 w-4 text-amber-400" /> Outils de codage
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <Link to="/referential/cim10" className="block">
              <div className="bg-slate-950/40 hover:bg-slate-800/60 transition rounded-lg p-3 border border-slate-800">
                <div className="text-xs font-semibold">CIM-10</div>
                <div className="text-[10px] text-slate-500">Codes diagnostic</div>
                <ArrowRight className="h-3 w-3 text-slate-500 mt-2" />
              </div>
            </Link>
            <Link to="/referential/cngap" className="block">
              <div className="bg-slate-950/40 hover:bg-slate-800/60 transition rounded-lg p-3 border border-slate-800">
                <div className="text-xs font-semibold">NGAP</div>
                <div className="text-[10px] text-slate-500">Nomenclature actes</div>
                <ArrowRight className="h-3 w-3 text-slate-500 mt-2" />
              </div>
            </Link>
            <Link to="/referential/ccam" className="block">
              <div className="bg-slate-950/40 hover:bg-slate-800/60 transition rounded-lg p-3 border border-slate-800">
                <div className="text-xs font-semibold">CCAM</div>
                <div className="text-[10px] text-slate-500">Classification commune</div>
                <ArrowRight className="h-3 w-3 text-slate-500 mt-2" />
              </div>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
